import { jsx as m } from "react/jsx-runtime";
import { QueryClientProvider as w, QueryClient as p } from "@tanstack/react-query";
import { createContext as x, useMemo as d, useContext as O } from "react";
const T = (e) => {
  console.warn(
    "PlatformUiProvider: notify() called but no handler was provided by the host.",
    e
  );
}, b = /* @__PURE__ */ new Set([
  // 'people',
  // 'course_work',
]), P = x(null);
function A({
  // Single account props (backwards compatible)
  executeQuery: e,
  locale: i = "en",
  timezone: c = "America/Denver",
  currentUserId: n,
  appContext: s = "canvas-academic",
  // Multi-account props
  accounts: o,
  perAccountLimit: u = 20,
  notify: v,
  permissions: l = {},
  queryClient: U = new p({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1e3,
        // 5 minutes
        retry: 1,
        refetchOnWindowFocus: !1,
        refetchOnMount: !1,
        refetchOnReconnect: !1
      }
    }
  }),
  children: h
}) {
  const r = d(() => {
    if (o)
      return o;
    if (e && n)
      return [
        {
          id: "default",
          name: "Canvas",
          executeQuery: e,
          currentUserId: n,
          locale: i,
          timezone: c,
          appContext: s
        }
      ];
    throw new Error(
      'PlatformUiProvider requires either "accounts" or single account props (executeQuery, currentUserId)'
    );
  }, [o, e, n, i, c, s]), f = v ?? T, y = d(() => {
    const t = r[0];
    return {
      accounts: r,
      getPrimaryAccount: () => t,
      getAccount: (a) => r.find((C) => C.id === a),
      isMultiAccountSupported: (a) => b.has(a),
      notify: f,
      perAccountLimit: u,
      permissions: l,
      // Backwards compatibility - delegate to primary account
      executeQuery: t.executeQuery,
      currentUserId: t.currentUserId,
      locale: t.locale || "en",
      timezone: t.timezone || "America/Denver",
      appContext: t.appContext || "canvas-academic"
    };
  }, [r, f, u, l]);
  return /* @__PURE__ */ m(P.Provider, { value: y, children: /* @__PURE__ */ m(w, { client: U, children: h }) });
}
function D() {
  const e = O(P);
  if (!e)
    throw new Error("usePlatformUi must be used within PlatformUiProvider");
  return e;
}
const g = A, I = D;
export {
  g as CanvasUiProvider,
  A as PlatformUiProvider,
  I as useCanvasUi,
  D as usePlatformUi
};
